<template>
  <div class="shippingPlan">
    <Flow v-bind:step="3"/>
    <div class="shippingPlan_wrap bg_white mt12">
      <h1 class="shippingPlan_title rb c5a">今後の配送プラン</h1>
    </div>
    <div v-for="(value, n) in planList" v-bind:class="[n != 0 ? 'mt12' : '']" class="planList_wrap bg_white pt16 pb16 boxs1" :key="n">
      <h2 class="planList_title ab"><span class="month rb">{{ value.targetMonth.slice(0, -1) }}</span>月</h2>
      <div v-if="value.hasDetail" class="ml16 mr16 ">
        <div v-for="(product, index) in value.detailList" class="planList_item ml16 mr16 bdb" :key="index">
          <p class="planList_item--title rb c5a">{{ product.categoryName }}</p>
          <div class="planList_item--detail">
            <p class="planList_item--count ar">数量<span class="count rm">{{ product.orderCount }}</span></p>
            <p class="planList_item--payment rb">{{ product.paymentMethodName }}</p>
            <p class="planList_item--status rb c5a">{{ product.shipmentStatus }}</p>
          </div>
        </div>
      </div>
      <div v-else class="ml16 mr16 mt16">
        <p class="rb c5a">{{ value.textOfEmptyList }}</p>
      </div>
    </div>
    <div class="btn_wrap bg_white mt12">
      <p class="shippingPlan_text rb">口座引落し払いの場合、口座引落し書類のお手続き完了まで「代金引換払い」でお届けいたします。<br><br>詳細はナチュラリープラスまでご連絡ください。</p>
      <router-link class="btn_blue" :to="{ name: 'subConfirm' }">次へ</router-link>
      <router-link class="btn_delete back_btn" :to="{ name: 'repeatSelectPaymentAndShipping' }">戻る</router-link>
    </div>
  </div>
</template>

<script>
import Flow from '@/components/subscription/Flow'

export default {
  components: {
    Flow,
  },
  data() {
    return {
      planList: []
    }
  },
  created() {
    let simulate = JSON.parse(localStorage.getItem('simulateResponse'));
    simulate ? this.planList.push(...simulate) : '';
  }
}
</script>

<style lang="css" scoped>
.shippingPlan_wrap {
  padding: 12px 0;
}
.shippingPlan_title {
  font-size: 14px;
  line-height: 1;
  text-align: center;
}

.planList_title {
  background-color: #4FCCD4;
  color: #fff;
  font-size: 18px;
  padding: 6.5px;
  text-align: center;
}

.planList_title .month {
  font-size: 30px;
}

.planList_item {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 26px;
  padding-bottom: 3px;
  flex-direction: column;
}
.planList_item--title {
  font-size: 16px;
  width: 100%;
}
.planList_item--detail {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}

.planList_item--count {
  font-size: 13px;
}
.planList_item--count .count {
  font-size: 17px;
  margin-left: 5px;
}
.planList_item--payment {
  font-size: 13px;
}
.planList_item--status {
  font-size: 13px;
}
.shippingPlan_text {
  color: #ff0000;
  font-size: 14px;
  line-height: 1.5;
  padding: 0 16px;
}

.btn_wrap {
  padding: 32px 0 80px;
}

.btn_blue {
  margin-top: 48px;
}
</style>



// WEBPACK FOOTER //
// src/views/subscription/ShippingPlan.vue